module.exports = __webpack_public_path__ + "static/jackpot_city-4a119a8ceed7d8c4f0d656816b08a8d6.png";